<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="17.626" height="15.121" viewBox="0 0 17.626 15.121">
		<g id="Learn" transform="translate(-98.576 -1.256)">
			<g id="Group_25626" data-name="Group 25626" transform="translate(99.326 2.006)">
				<path
					id="Path_20312"
					data-name="Path 20312"
					d="M115.453,6.336,107.6,10.757l-8.27-4.421,8.27-4.33Z"
					transform="translate(-99.326 -2.006)"
					fill="none"
					stroke="#5a677d"
					stroke-linejoin="round"
					stroke-width="1.5"
				/>
				<path
					id="Path_20313"
					data-name="Path 20313"
					d="M106.4,5.77l3.88,2.385V15.1"
					transform="translate(-98.34 -1.482)"
					fill="none"
					stroke="#5a677d"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.5"
				/>
				<path
					id="Path_20314"
					data-name="Path 20314"
					d="M113.915,6.447l.036,1.5c.043,1.75-.05,2.871-1.735,3.628-1.363.612-3.858,2.368-4.713,2.377-.9.011-2.661-1.1-4.053-1.967a4.648,4.648,0,0,1-2.671-3.962V6.447"
					transform="translate(-99.124 -1.387)"
					fill="none"
					stroke="#5a677d"
					stroke-linejoin="round"
					stroke-width="1.5"
				/>
			</g>
		</g>
	</svg>
</template>
<script>
export default { name: 'LearnSVG' };
</script>
